import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from '../modules/shared/services/common.service';
import { Messages } from '../enums/messages.enums';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  private connectionStatus = new BehaviorSubject<boolean>(this.isOnline());
  private renderer: Renderer2;

  constructor(
    private readonly cs: CommonService,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.addEventListeners();
  }

  private isOnline(): boolean {
    // Check if running in the browser
    if (typeof navigator !== 'undefined') {
      return navigator?.onLine;
    }
    return true; // Default to offline in SSR
  }

  private addEventListeners() {
    // Check if running in the browser before adding listeners
    if (this.cs.isBrowser && typeof window !== 'undefined') {
      this.renderer.listen('window', 'offline', () => this.updateOnlineStatus());
    }
  }

  private updateOnlineStatus() {
    const isOnline = this.isOnline();
    this.connectionStatus.next(isOnline);
    if (!isOnline) {
      this.cs.showErrorMessage(Messages.INTERNET_LOST);
    }
  }

  getConnectionStatus() {
    return this.connectionStatus.asObservable();
  }
}